import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import './kycstyle.css';
import moment from "moment";
import { Link } from "react-router-dom";
import { store } from "../../redux/store";
import { setROId } from "../../redux/retailer-kyc-details/retailer-kyc-details.action";


const httpClient = axios.create();
class KycDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            personalInfo: '',
            kycProcessErr: ''
        }
    }


    componentDidMount() {
        this.getSessionDetails();
    }
    componentWillUnmount() {
    }

    getSessionDetails = () => {
        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.i
        };

        httpClient.get('/api/v1/retailer/onboard/session/' + this.props.registerRetailerResponse.sessionId
            , { headers }
        ).then((response) => {
            console.log('session Id retailer response' + JSON.stringify(response.data));
            this.setState({
                personalInfo: response.data.personalInfo
            })


        }).catch(error => {
            alert(error.message);
    

        });
    }

    goToKycPage = () => {
        var goToKycProcessPage = document.getElementById('goToKycProcessPage');
        goToKycProcessPage.click();
    }

    backToAddressDetails = () => {
        var backToAddressDetailsBtn = document.getElementById('backToAddressDetailsBtn');
        backToAddressDetailsBtn.click();
    }

    render() {

        return (

            <div class="mid-contant">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <div class="head1">

                            </div>
                        </div>
                        <div class="col-12">
                            <div class="registerbox">
                                <div class="row">
                                    <div class="col-12 col-lg-7">
                                        <form action="index.html">
                                            <div class="row">
                                                <div class="col-12">
                                                    <div class="successtxt">
                                                        <h3><i class="success"></i> Congratulations </h3>
                                                        <p>Dear <strong>{this.state.personalInfo != ''
                                                            && (this.state.personalInfo.fname != null && this.state.personalInfo.fname != '' &&
                                                                this.state.personalInfo.fname != undefined) ? this.state.personalInfo.fname : 'NA'
                                                                + ' ' +
                                                                (this.state.personalInfo.lname != null && this.state.personalInfo.lname != '' &&
                                                                    this.state.personalInfo.lname != undefined) && this.state.personalInfo.lname
                                                        }</strong>,</p>
                                                        <p>Welcome to FinXpay, Now login to FinXpay App with RO code & password sent to your registered mobile number:
                                                            +91-{(this.state.personalInfo.mobile != null && this.state.personalInfo.mobile != '' &&
                                                                this.state.personalInfo.mobile != undefined) ? this.state.personalInfo.mobile : 'NA'}</p>

                                                        <p><strong>Happy Earning.</strong></p>
                                                        <h6><img src="images/icon.png" alt="" /> RO Code: {(this.props.roResponse != null &&
                                                            this.props.roResponse.retailerId != null) ? this.props.roResponse.retailerId : 'NA'} <i class="copy"></i></h6>
                                                    </div>
                                                </div>



                                                <div class="col-12">
                                                    {/* <Link to='/kyc-process'> */}
                                                    <button type="button" class="btn btn-primary" id=""
                                                        onClick={this.goToKycPage}>Next</button>
                                                    {/* </Link> */}
                                                </div>
                                                {this.state.kycProcessErr != '' &&
                                                    <div class='valid-error'>
                                                        {this.state.kycProcessErr}</div>}
                                            </div>
                                        </form>
                                    </div>

                                    <div class="col-12 col-lg-5">
                                        {/* <div class="topbtn">
                                            <a onClick={this.backToAddressDetails}>Back</a>
                                        </div> */}
                                        <Link to='/add-business-details'>
                                            <button id='backToAddressDetailsBtn' hidden={true}></button>
                                        </Link>
                                        <Link to='/kyc-process'>
                                            <button id='goToKycProcessPage' hidden={true}></button>
                                        </Link>
                                        <div class="rightbanner"><img src="images/success-img.png" alt="Oxigen" class="img-fluid" /></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage, otpErrorMessage },
        miscReduce: { phone, agentInfo, token },
        retailerKycReduce: { registerRetailerResponse, personalInfo, roResponse }
    }
) => ({
    errorMessage, loginErrorMessage, otpErrorMessage, phone, agentInfo, token, registerRetailerResponse, personalInfo, roResponse
});

export default connect(mapStateToProps, null)(KycDetails);
